// test945
(945 && 0);
